class Script {
  constructor(settings = {}) {
    let urlParams = new URLSearchParams(window.location.search)

    this.settings = settings
    this.isReady = false
    this.isMobile = window.matchMedia("(max-width: 767px)").matches
    this.domain = window.location.hostname
    this.debug = urlParams.has("galaxy_debug")
  }

  load() {
    throw new TypeError("Cannot construct Script instances directly")
  }

  loadDelayedSlots() {
    document.querySelectorAll("[data-delayed]").forEach((slot) => {
      slot.dataset.delayed = ""
    })
    this._debugger("ad-manager", "done loadDelayedSlots()")
  }

  refresh() {
    // Still nothing here ...
  }

  _debugger_nolabels(text, type = "log") {
    if (this.debug) {
      try {
        console[type](text)
      } catch (e) {
        console.error("Errore nel debugging di un elemento!")
      }
    }
  }

  _debugger(title, text, obj = null, type = "log") {
    if (this.debug) {
      let firstLabel = "%cGalaxyNetwork"
      let firstBgColor = "#fac802"
      let firstStyle = `background:${firstBgColor};color:#fff;border-radius:4px;font-weight:bold;padding: 1px 4px`

      firstLabel += `%c${title.replaceAll("-", " ")}`
      let secondBgColor = ""
      switch (title) {
        case "ad-manager":
          secondBgColor = "#c75a5a"
          break
        case "amazon-hb":
          secondBgColor = "#89c454"
          break
        case "bidder":
          secondBgColor = "#2878b5"
          break
        case "demand-manager":
          secondBgColor = "#2fc4c2"
          break
        case "iubenda":
          secondBgColor = "#26b569"
          break
        case "viralize":
          secondBgColor = "#8428b5"
          break
        default:
          secondBgColor = "#615c63"
      }
      let secondStyle = `margin-left:5px;text-transform:capitalize;background:${secondBgColor};color:#fff;border-radius:4px;font-weight:bold;padding: 1px 4px`

      try {
        console[type](
          firstLabel,
          firstStyle,
          secondStyle,
          text,
          obj !== null ? obj : ""
        )
      } catch (e) {
        console.error(
          firstLabel,
          firstStyle,
          "Errore nel debugging di un elemento!"
        )
      }
    }
  }
}

export default Script
